<template>
  <div>
    <v-layout class="mt-5">
      <v-flex lg1>
        <Validate :v="$v.form.anoletivo">
          <v-select
            slot-scope="{ props }"
            v-bind="props"
            outlined
            menu-props="offsetY"
            no-data-text="Opções não disponíveis"
            append-icon="arrow_drop_down"
            label="Ano Letivo*"
            :items="anoOptions"
            :disabled="loading"
            :background-color="loading ? '#f2f2f2' : null"
            v-model="$v.form.anoletivo.$model"
            @change="onChangeAnoOptions"
          />
        </Validate>
      </v-flex>
      <v-flex lg5 ml-3>
        <Validate :v="$v.form.identificadorescolalocalexterno">
          <v-autocomplete
            slot-scope="{ props }"
            v-bind="props"
            v-model="form.identificadorescolalocalexterno"
            :items="escolaOptions"
            item-text="nomeescola"
            item-value="identificadorescolalocalexterno"
            outlined
            :disabled="loading || !form.anoletivo"
            :background-color="loading || !form.anoletivo ? '#f2f2f2' : null"
            label="Unidade Escolar*"
            :no-data-text="escolasLoading ? 'Carregando dados, aguarde...' : escolaSearch ? `Nenhuma opção encontrada com '${escolaSearch}'` : 'Nenhuma opção carregada'"
            :search-input.sync="escolaSearch"
            :loading="escolasLoading"
            loader-height="3"
            @focus="loadEscolaOptions"
            @change="onChangeEscolaOptions"
          ></v-autocomplete>
        </Validate>
      </v-flex>
      <v-flex lg6 ml-3>
        <Validate :v="$v.form.identificadortitulocardapio">
          <v-autocomplete
            slot-scope="{ props }"
            v-bind="props"
            v-model="form.identificadortitulocardapio"
            :items="cardapioOptions"
            item-text="descricaotitulocardapio"
            item-value="identificadortitulocardapio"
            outlined
            :disabled="loading || !form.identificadorescolalocalexterno"
            :background-color="loading || !form.identificadorescolalocalexterno ? '#f2f2f2' : null"
            label="Título Cardápio*"
            :no-data-text="cardapiosLoading ? 'Carregando dados, aguarde...' : cardapioSearch ? `Nenhuma opção encontrada com '${cardapioSearch}'` : 'Nenhuma opção carregada'"
            :search-input.sync="cardapioSearch"
            :loading="cardapiosLoading"
            loader-height="3"
            @focus="loadCardapioOptions"
            @change="onChangeCardapioOptions"
          ></v-autocomplete>
        </Validate>
      </v-flex>
    </v-layout>

    <v-layout class="mb-5" justify-space-between>
      <v-flex lg3>
        <v-checkbox
          label="Usar dados do ano anterior para a previsão"
          hide-details
          style="margin:0px;padding:0px;"
          v-model="form.usarAnoAnterior"
          :disabled="loading || !form.identificadortitulocardapio"
          @change="(e) => { }">
        </v-checkbox>
      </v-flex>
      <v-flex lg2 class="text-right">
        <v-btn class="rounded-sm font-weight-regular" type="button" color="teal" @click="processarCarregandoCota" small :loading="loading" :dark="botaoCarregarCotaEstaAtivo && !salvarLoading" :disabled="!botaoCarregarCotaEstaAtivo || salvarLoading">Carregar cota</v-btn>
      </v-flex>
    </v-layout>

    <v-card class="mb-5" v-if="cota.length">
      <div class="pa-3 mt-2">
          <div><strong>Total de alunos do cardápio:</strong> {{ totalAlunosDoCardapio }}</div>
      </div>
    </v-card>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-card>
        <table class="table-siged" style="position: relative">
          <colgroup>
          <col />
          <col />
          <col style="background-color: #f3f3f3"/>
          <col />
          <col style="background-color: #f3f3f3"/>
          <col />
          <col style="background-color: #f3f3f3"/>
          <col />
          <col style="background-color: #f3f3f3"/>
          <col />
          </colgroup>
          <thead>
            <tr>
              <th class="headcol" style="width: 350px;">Alimento</th>
              <th class="headcol">1º Semana<br>Quant. Prevista</th>
              <th class="headcol" style="background-color: white;">1º Semana<br>Cota</th>
              <th class="headcol">2º Semana<br>Quant. Prevista</th>
              <th class="headcol" style="background-color: white;">2º Semana<br>Cota</th>
              <th class="headcol">3º Semana<br>Quant. Prevista</th>
              <th class="headcol" style="background-color: white;">3º Semana<br>Cota</th>
              <th class="headcol">4º Semana<br>Quant. Prevista</th>
              <th class="headcol" style="background-color: white;">4º Semana<br>Cota</th>
              <th class="headcol">Cota Total Mês</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in cota" :key="item.idalimento" :class="'hover-' + item.grupo">
              <td :style="{'backgroundColor': groupColor(item.grupo) }">{{ item.alimento }}</td>
              <td style="text-align:center;">{{ item.primeiraSemanaPrevista ? Number(item.primeiraSemanaPrevista).toFixed(2) : '' }}</td>
              <td style="text-align:center;"><input-cota :validate="validate" :disabled="!item.primeiraSemanaPrevista" v-model.number="item.primeiraSemanaCota" @input="item.cotaMensal = calcularCotaTotalAlimento(item.primeiraSemanaCota, item.segundaSemanaCota, item.terceiraSemanaCota, item.quartaSemanaCota)" /></td>
              <td style="text-align:center;">{{item.segundaSemanaPrevista ? Number(item.segundaSemanaPrevista).toFixed(2) : '' }}</td>
              <td style="text-align:center;"><input-cota :validate="validate" :disabled="!item.segundaSemanaPrevista"  v-model.number="item.segundaSemanaCota"  @input="item.cotaMensal = calcularCotaTotalAlimento(item.primeiraSemanaCota, item.segundaSemanaCota, item.terceiraSemanaCota, item.quartaSemanaCota)"/></td>
              <td style="text-align:center;">{{ item.terceiraSemanaPrevista ? Number(item.terceiraSemanaPrevista).toFixed(2) : '' }}</td>
              <td style="text-align:center;"><input-cota :validate="validate" :disabled="!item.terceiraSemanaPrevista"  v-model.number="item.terceiraSemanaCota"  @input="item.cotaMensal = calcularCotaTotalAlimento(item.primeiraSemanaCota, item.segundaSemanaCota, item.terceiraSemanaCota, item.quartaSemanaCota)"/></td>
              <td style="text-align:center;">{{ item.quartaSemanaPrevista ? Number(item.quartaSemanaPrevista).toFixed(2) : ''}}</td>
              <td style="text-align:center;"><input-cota :validate="validate"  :disabled="!item.quartaSemanaPrevista" v-model.number="item.quartaSemanaCota"  @input="item.cotaMensal = calcularCotaTotalAlimento(item.primeiraSemanaCota, item.segundaSemanaCota, item.terceiraSemanaCota, item.quartaSemanaCota)"/></td>
              <td style="text-align:center;">{{ item.cotaMensal ? Number(item.cotaMensal).toFixed(2) : 0}}</td>
            </tr>
            <tr v-show="cota.length == 0" style="background-color: rgb(242, 242, 242);">
              <td colspan="10">Nenhum item carregado.</td>
            </tr>
          </tbody>
        </table>
    </v-card>

    <v-layout class="mt-5 mb-2" justify-end>
      <v-flex shrink ml-3 class="text-right" align-self-center>
        <v-btn class="rounded-sm font-weight-regular" type="button" color="teal" small :loading="salvarLoading" :dark="botaoSalvarEstaAtivo" :disabled="!botaoSalvarEstaAtivo" @click="salvarCota()">Salvar</v-btn>
      </v-flex>
    </v-layout>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
      <div class="d-flex justify-space-between align-center">
          <span> {{ submitText }}</span>
          <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import _ from 'lodash';
import { required, integer, alphaNum } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import InputCota from "@/components/InputCota";

const CardapioEscolaRepository = RepositoryFactory.get("cardapioEscola");
const CotaAlimentarRepository = RepositoryFactory.get("cotaAlimentar");

const setFormInicial = () => ({
  anoletivo: '',
  identificadorescolalocalexterno: '',
  identificadortitulocardapio: '',
  usarAnoAnterior: false,
});

export default {
  name: 'Cota',

  components: {
    InputCota
  },

  data() {
    return {
      form: setFormInicial(),
      escolaOptions: [],
      escolasLoading: false,
      escolaSearch: '',
      cardapioOptions: [],
      cardapiosLoading: false,
      cardapioSearch: '',
      cota: [],
      totalAlunosDoCardapio: null,
      loading: false,
      salvarLoading: false,
      snackbar: false,
      submitText: '',
      msgArrayError: [],
      validate: false,
    };
  },

  mounted() {
    this.$Progress.finish();
  },

  computed: {
    anoOptions() {
      let retornoOptions = [];
      for(let i = new Date().getFullYear(); i >= 2023; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
    botaoCarregarCotaEstaAtivo() {
      return this.form.anoletivo != '' &&
             this.form.identificadorescolalocalexterno != '' &&
             this.form.identificadortitulocardapio != '';
    },
    botaoSalvarEstaAtivo() {
      return this.botaoCarregarCotaEstaAtivo && this.cota.length > 0;
    }
  },

  validations: {
    form: {
      anoletivo: { required, integer },
      identificadorescolalocalexterno: { required, alphaNum },
      identificadortitulocardapio: { required, integer },
    },
    cota: {
      required,
      $each: {
        idalimento: { required },
        alimento: { required },
        grupo: { required },
        primeiraSemanaPrevista: { required },
        primeiraSemanaCota: { required },
        segundaSemanaPrevista: { required },
        segundaSemanaCota: { required },
        terceiraSemanaPrevista: { required },
        terceiraSemanaCota: { required },
        quartaSemanaPrevista: { required },
        quartaSemanaCota: { required },
        cotaMensal: { required }
      }
    }
  },

  methods: {
    async loadEscolaOptions() {
      if (this.escolaOptions.length) {
        return
      }

      this.escolasLoading = true
      const { data } = await CardapioEscolaRepository.recebeMerenda();
      for (const key of data.results) {
        this.escolaOptions.push({ identificadorescolalocalexterno: key.identificadorescolalocalexterno, nomeescola: key.identificadorescolalocalexterno.slice(0, -1) + ' - ' + key.nomeescola })
      }
      this.escolasLoading = false
    },
    async loadCardapioOptions() {
      if (this.cardapioOptions.length) {
        return
      }

      this.cardapiosLoading = true
      const { data } = await CardapioEscolaRepository.buscarCardapiosPorUnidadeEscolar(this.form.anoletivo, this.form.identificadorescolalocalexterno);
      this.cardapioOptions = data.results;
      this.cardapiosLoading = false
    },
    onChangeAnoOptions() {
      this.form.identificadorescolalocalexterno = '';
      this.escolaOptions = [];
      this.form.identificadortitulocardapio = '';
      this.form.usarAnoAnterior = false;
      this.cardapioOptions = [];
      this.cota = [];
      this.msgArrayError = [];
    },
    onChangeEscolaOptions() {
      this.form.identificadortitulocardapio = '';
      this.form.usarAnoAnterior = false;
      this.cardapioOptions = [];
      this.cota = [];
      this.msgArrayError = [];
    },
    onChangeCardapioOptions() {
      this.form.usarAnoAnterior = false;
      this.cota = [];
      this.msgArrayError = [];
    },

    async processarCarregandoCota() {
      this.cota = [];
      this.loading = true;
      this.msgArrayError = []

      const cotaPrevista = CotaAlimentarRepository.calcularCotaPrevista(this.form.anoletivo, this.form.identificadorescolalocalexterno, this.form.identificadortitulocardapio, this.cardapioOptions.find(c => c.identificadortitulocardapio == this.form.identificadortitulocardapio).identificadorcardapioescola, this.form.usarAnoAnterior ? 1 : 0);
      const cotaEffetiva = CotaAlimentarRepository.carregarCotaEfetiva(this.form.anoletivo, this.form.identificadorescolalocalexterno, this.cardapioOptions.find(c => c.identificadortitulocardapio == this.form.identificadortitulocardapio).identificadorcardapioescola);

      try {
        const result = await Promise.all([cotaPrevista, cotaEffetiva]);
        if (result[0].data.results.length) {
          this.processarCotaPrevista(result[0].data.results);
          this.mesclarCotaPrevistaComEfetiva(result[1].data.results);
        } else {
          this.msgArrayError = ['Não há informações suficientes no sistema para calcular a cota prevista.'];
          if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        }
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        else { this.msgArrayError = ['Houve algum erro inesperado. Contate o administrador do sistema.']; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }
      finally {
        this.loading = false;
      }
    },

    async processarCotaPrevista(cotaPrevista) {
      this.totalAlunosDoCardapio = cotaPrevista?.[0]?.totalalunosdocardapio;

      let cotaPrevistaOrdenada = _.orderBy(cotaPrevista, "identificadorgrupoalimentomerenda");

      let cotaPrevistaAgrupada = _.groupBy(cotaPrevistaOrdenada, "descricaocomposicaoalimentopadrao");

      Object.entries(cotaPrevistaAgrupada).forEach( ([a, c]) => {
        let cotaPrevista = {
          idalimento: c[0].identificadorcomposicaoalimentopadrao,
          alimento: c[0].descricaocomumalimento,
          grupo: c[0].identificadorgrupoalimentomerenda,
          primeiraSemanaPrevista: 0,
          primeiraSemanaCota: null,
          segundaSemanaPrevista: 0,
          segundaSemanaCota: null,
          terceiraSemanaPrevista: 0,
          terceiraSemanaCota: null,
          quartaSemanaPrevista: 0,
          quartaSemanaCota: null,
          cotaMensal: 0
        }
        c.forEach(ci => {
          if (ci.semanacardapio == "1") cotaPrevista.primeiraSemanaPrevista = ci.cota_prevista / ci.fatortransformacaounidade
          else if (ci.semanacardapio == "2") cotaPrevista.segundaSemanaPrevista = ci.cota_prevista / ci.fatortransformacaounidade
          else if (ci.semanacardapio == "3") cotaPrevista.terceiraSemanaPrevista = ci.cota_prevista / ci.fatortransformacaounidade
          else if (ci.semanacardapio == "4") cotaPrevista.quartaSemanaPrevista = ci.cota_prevista / ci.fatortransformacaounidade
        })

        this.cota.push(cotaPrevista);
      });
    },

    async mesclarCotaPrevistaComEfetiva(cotaEfetiva) {
      this.cota = this.cota.map( c => {
        let ce = cotaEfetiva.filter( alimento => alimento.identificadoralimento == c.idalimento);
        if (ce.length > 0) {
          c.primeiraSemanaCota = ce[0].quantidadeprimeirasemanarealizada;
          c.segundaSemanaCota = ce[0].quantidadesegundasemanarealizada;
          c.terceiraSemanaCota = ce[0].quantidadeterceirasemanarealizada;
          c.quartaSemanaCota = ce[0].quantidadequartasemanarealizada;
          c.cotaMensal = ce[0].quantidadetotal;
        }
        return c
      });
    },

    async salvarCota() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.validate = true;
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        return;
      }

      this.salvarLoading = true;
      this.msgArrayError = []

      try {
        const { data } = await CotaAlimentarRepository.salvarCota(this.cardapioOptions.find(c => c.identificadortitulocardapio == this.form.identificadortitulocardapio).identificadorcardapioescola, this.totalAlunosDoCardapio, this.cota);
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.$v.$reset();
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        else { this.msgArrayError = ['Houve algum erro inesperado. Contate o administrador do sistema.']; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.salvarLoading = false;
      }
    },

    calcularCotaTotalAlimento(cotaPrimeiraSemana, cotaSegundaSemana, cotaTerceiraSemana, cotaQuartaSemana) {
      let cotaTotalAlimento = 0;
      cotaTotalAlimento += Number(cotaPrimeiraSemana || 0);
      cotaTotalAlimento += Number(cotaSegundaSemana || 0);
      cotaTotalAlimento += Number(cotaTerceiraSemana || 0);
      cotaTotalAlimento += Number(cotaQuartaSemana || 0);
      return cotaTotalAlimento;
    },

    groupColor(cor) {
      let cores = [ "#f2f2f2", "#efe7c7", "#d5e0d6", "#c3c3c3" ];
      return cores[cor - 1];
    },
  }
};
</script>

<style scoped>
.table-siged tbody tr:nth-child(odd),
.table-siged tbody tr:nth-child(even) {
  background-color: unset;
}
.invalid-format {
  border: 1px solid red !important;
}

.hover-1:hover { background-color: #f2f2f2 !important; }
.hover-2:hover { background-color: #efe7c7 !important; }
.hover-3:hover { background-color: #d5e0d6 !important; }
.hover-4:hover { background-color: #c3c3c3 !important; }
</style>
